import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import "./ReferralCard.css";

function ReferralCard({ referralCode: propCode }) {
  const { user } = useContext(AuthContext);
  const [copied, setCopied] = useState(false);

  const referralCode = propCode || user?.referralCode;

  if (!referralCode) return null;

  const referralLink = `${window.location.origin}/signup?ref=${referralCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="referral-card">
      <div className="ref-card-header">
        <div className="ref-gift-icon">🎁</div>
        <div className="ref-header-text">
          <h4>Refer & Get 1 Month PRO</h4>
          <p>Invite a friend. When they complete Phase 1, you both win.</p>
        </div>
      </div>

      <div className="ref-link-box">
        <input 
          type="text" 
          value={referralLink} 
          readOnly 
          className="ref-input"
        />
        <button 
          onClick={handleCopy} 
          className={`ref-copy-btn ${copied ? "copied" : ""}`}
        >
          {copied ? "Copied!" : "Copy Link"}
        </button>
      </div>

      <div className="ref-stats-mini">
        <div className="ref-stat-item">
          <span className="ref-stat-val">30 Days</span>
          <span className="ref-stat-label">Reward per friend</span>
        </div>
        <div className="ref-stat-divider" />
        <div className="ref-stat-item">
          <span className="ref-stat-val">Unlimited</span>
          <span className="ref-stat-label">Max rewards</span>
        </div>
      </div>
    </div>
  );
}

export default ReferralCard;
